export default "__VITE_ASSET__DR51AZqv__"